import { render, staticRenderFns } from "./dongtai.vue?vue&type=template&id=5669eebe&scoped=true"
import script from "./dongtai.vue?vue&type=script&lang=js"
export * from "./dongtai.vue?vue&type=script&lang=js"
import style0 from "./dongtai.vue?vue&type=style&index=0&id=5669eebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669eebe",
  null
  
)

export default component.exports